import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WSharingOptionsVerticalCCD: IClientComponentDefinition = {
  name: 'WSharingOptionsVertical',
  load: () =>
    import(/* webpackChunkName: 'WSharingOptionsVertical' */ './sharing-options-vertical'),
}
